import site from "../site";
import Tracking from "./tracking";
import ShareLink from "./share-link";

declare var $: any;

export default class WishlistShare {

	private myselfShowTrigger = document.querySelector('.js-wishlist-email-myself-trigger');
	private friendShowTrigger = document.querySelector('.js-wishlist-email-friend-trigger');
	private shareLinkTrigger = document.querySelector('.js-wishlist-share-link-trigger');
	private myselfFormContainer = document.querySelector('.js-wishlist-email-self');
	private friendFormContainer = document.querySelector('.js-wishlist-email-friend');
	private shareLinkContainer = document.querySelector('.js-wishlist-share-link');
	private myselfForm = document.querySelector('.js-wishlist-email-self-form') as HTMLFormElement;
	private friendForm = document.querySelector('.js-wishlist-email-friend-form') as HTMLFormElement;
	private shareLinkSection = document.querySelector('.js-wishlist-share-link') as HTMLDivElement;
	private shareLinkInputField = document.querySelector('.js-wishlist-share-link-input') as HTMLInputElement;
	private NameValidationRegExp = /^[A-Za-z\s\-]+$/;

	private UnexpectedErrorMessage = "An unexpected error occurred when trying to email your wishlist. Please try again later.";

	constructor() {
		if (!this.shareLinkSection) {
			return;
		}

		const shareButton = document.querySelector('.js-wishlist-share-link-button') as HTMLButtonElement | null;
		const shareInput = this.shareLinkInputField;
		const shareHelper = new ShareLink({
			shareTitle: `My Wishlist at ${site.activeSiteSetting}`,
			shareText: `View my Wishlist on ${site.activeSiteSetting}:`,
			trackingCategory: 'wishlist',
			trackingMedium: 'link',
			trackingContent: 'wishlist_link_share',
			trackingAction: 'Link',
			trackingLabel: 'Wishlist',
			tooltipSelector: '.js-wishlist-share-link-button-tooltip'
		});
		if (shareButton) {
			shareButton.addEventListener('click', () => {
				shareHelper.shareUrl(shareInput.value, shareInput, true);
			});
		}
		this.showMySelfForm();
		this.attachEvents();
	}

	private attachEvents() {

		this.myselfShowTrigger.addEventListener('click', () => {
			this.showMySelfForm();
		});

		this.friendShowTrigger.addEventListener('click', () => {
			this.showFriendForm();
		});

		this.shareLinkTrigger.addEventListener('click', () => {
			this.showShareLinkSection();
		});

		this.myselfForm.addEventListener('submit', (event) => {
			this.shareWishlistSelf(event);
		});

		this.friendForm.addEventListener('submit', (event) => {
			this.shareWishlistFriend(event);
		});

	}

	private shareWishlistSelf(event) {
		event.preventDefault();

		if (!$(this.myselfForm).valid()) {
			return;
		}

		const myselfName = this.myselfForm.querySelector('.js-wishlist-email-self-name') as HTMLInputElement;
		const myselfEmail = this.myselfForm.querySelector('.js-wishlist-email-self-email') as HTMLInputElement;
		const myselfConsent = this.myselfForm.querySelector('.js-wishlist-email-self-consent') as HTMLInputElement;

		if (myselfName.value !== "" && !myselfName.value.match(this.NameValidationRegExp)) {
			this.showEmailSelfNameErrorMessage("Name field can only contain letters, spaces and hyphens");
			return;
		}

		if (myselfName.value.length > 30) {
			this.showEmailSelfNameErrorMessage("Name length cannot be greater than 30 characters");
			return;
		}

		var jsonMyselfForm = {
			"name": myselfName.value,
			"email": myselfEmail.value,
			"marketingconsent": myselfConsent.checked,
			"sharelink": Tracking.addCampaignTracking(this.plainShareUrl(), 'wishlist', 'email', 'wishlist_email_self')
		}

		if ($("div.g-recaptcha").length > 0) {
			var recaptchaResponse = grecaptcha.getResponse(0);
			if (recaptchaResponse.length == 0) {
				this.showEmailSelfResponseErrorMessage("reCaptcha is required");
				return false;
			}
			else {
				jsonMyselfForm["recaptcharesponse"] = recaptchaResponse;
			}
		}

		fetch("/api/wishlist/email-self", {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST',
			body: JSON.stringify(jsonMyselfForm)
		}).then((response) => {
			if (response.status == 200) {
				Tracking.trackShare('Email Self', 'Wishlist', jsonMyselfForm.sharelink);
				this.myselfForm.submit();
			} else {
				response.json()
					.then((data) => {
						this.showEmailSelfResponseErrorMessage(this.UnexpectedErrorMessage);
					})
			}
		}).catch((error) => {
			this.showEmailSelfResponseErrorMessage(this.UnexpectedErrorMessage);
		});
	}

	private shareWishlistFriend(event) {
		event.preventDefault();

		if (!$(this.friendForm).valid()) {
			return;
		}

		const senderName = this.friendForm.querySelector('.js-wishlist-email-friend-name') as HTMLInputElement;
		const senderEmail = this.friendForm.querySelector('.js-wishlist-email-friend-your-email') as HTMLInputElement;
		const friendEmail = this.friendForm.querySelector('.js-wishlist-email-friend-email') as HTMLInputElement;

		if (!senderName.value.match(this.NameValidationRegExp)) {
			this.showEmailFriendNameErrorMessage("Name field can only contain letters, spaces and hyphens");
			return;
		}

		if (senderName.value.length > 30) {
			this.showEmailFriendNameErrorMessage("Name length cannot be greater than 30 characters");
			return;
		}

		const jsonFriendForm = {
			"sendername": senderName.value,
			"senderemail": senderEmail.value,
			"recipientemail": friendEmail.value,
			"sharelink": Tracking.addCampaignTracking(this.plainShareUrl(), 'wishlist', 'email', 'wishlist_email_friend')
		}

		if ($("div.g-recaptcha").length > 0) {
			var recaptchaResponse = grecaptcha.getResponse(1);
			if (recaptchaResponse.length == 0) {
				this.showEmailFriendResponseErrorMessage("reCaptcha is required");
				return false;
			}
			else {
				jsonFriendForm["recaptcharesponse"] = recaptchaResponse;
			}
		}

		fetch("/api/wishlist/email-friend", {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST',
			body: JSON.stringify(jsonFriendForm)
		}).then((response) => {
			if (response.status == 200) {
				Tracking.trackShare('Email Friend', 'Wishlist', jsonFriendForm.sharelink);
				this.friendForm.submit();
			} else {
				response.json().then((data) => {
					this.showEmailFriendResponseErrorMessage(this.UnexpectedErrorMessage);
				});
			}
		}).catch((error) => {
			this.showEmailFriendResponseErrorMessage(this.UnexpectedErrorMessage);
		});
	}

	private showEmailSelfResponseErrorMessage(message: string) {
		const responseError = this.myselfForm.querySelector('.js-wishlist-email-self-response-error');
		const responseErrorMessage = this.myselfForm.querySelector('.js-wishlist-email-self-response-error-message');
		responseErrorMessage.textContent = message;
		responseErrorMessage.removeAttribute("hidden");
		responseError.removeAttribute("hidden");
	}

	private showEmailSelfNameErrorMessage(message: string) {
		const nameErrorMessage = this.myselfForm.querySelector('.js-wishlist-email-self-name-error-message');
		nameErrorMessage.textContent = message;
		nameErrorMessage.removeAttribute("hidden");
	}

	private showEmailFriendResponseErrorMessage(message: string) {
		const responseError = this.friendForm.querySelector('.js-wishlist-email-friend-response-error');
		const responseErrorMessage = this.friendForm.querySelector('.js-wishlist-email-friend-response-error-message');
		responseErrorMessage.textContent = message;
		responseErrorMessage.removeAttribute("hidden");
		responseError.removeAttribute("hidden");
	}

	private showEmailFriendNameErrorMessage(message: string) {
		const nameErrorMessage = this.friendForm.querySelector('.js-wishlist-email-friend-name-error-message');
		nameErrorMessage.textContent = message;
		nameErrorMessage.removeAttribute("hidden");
	}

	private showMySelfForm() {
		this.myselfShowTrigger.classList.add('is-selected');
		this.friendShowTrigger.classList.remove('is-selected');
		this.shareLinkTrigger.classList.remove('is-selected');
		this.myselfFormContainer.setAttribute('aria-hidden', 'false');
		this.friendFormContainer.setAttribute('aria-hidden', 'true');
		this.shareLinkContainer.setAttribute('aria-hidden', 'true');
	}

	private showFriendForm() {
		this.friendShowTrigger.classList.add('is-selected');
		this.myselfShowTrigger.classList.remove('is-selected');
		this.shareLinkTrigger.classList.remove('is-selected');
		this.friendFormContainer.setAttribute('aria-hidden', 'false');
		this.myselfFormContainer.setAttribute('aria-hidden', 'true');
		this.shareLinkContainer.setAttribute('aria-hidden', 'true');
	}

	private showShareLinkSection() {
		this.shareLinkTrigger.classList.add('is-selected');
		this.myselfShowTrigger.classList.remove('is-selected');
		this.friendShowTrigger.classList.remove('is-selected');
		this.shareLinkContainer.setAttribute('aria-hidden', 'false');
		this.myselfFormContainer.setAttribute('aria-hidden', 'true');
		this.friendFormContainer.setAttribute('aria-hidden', 'true');
	}

	private plainShareUrl(): string {
		try {
			const url = new URL(this.shareLinkInputField.value);
			['utm_source', 'utm_medium', 'utm_campaign'].forEach(p => url.searchParams.delete(p));
			return url.toString();
		} catch {
			return this.shareLinkInputField.value;
		}
	}

}
